import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "indexBannerFiltersWrapper" }
const _hoisted_2 = { class: "indexBannerFilters" }
const _hoisted_3 = ["onClick", "aria-label"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = ["srcset"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilters, (currentFilter) => {
        return (_openBlock(), _createElementBlock("ul", {
          class: "itemWrapper",
          key: currentFilter.tagId,
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "400"
        }, [
          _createElementVNode("li", {
            class: _normalizeClass(["preselected-item", 
            _ctx.selectedFilter?.tagId &&
              currentFilter.tagId === _ctx.selectedFilter.tagId &&
              'active'
          ])
          }, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: ($event: any) => (_ctx.clickFilters(currentFilter.tagId)),
              "aria-label": currentFilter.tagName
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("picture", null, [
                  _createElementVNode("source", {
                    srcset: currentFilter.image,
                    media: "(min-width: 767px)"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("source", {
                    srcset: currentFilter.imageMobile,
                    media: "(min-width: 0px)"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("img", {
                    src: currentFilter.image,
                    alt: "",
                    role: "presentation"
                  }, null, 8, _hoisted_7)
                ])
              ]),
              _createElementVNode("span", {
                id: `tag_${currentFilter.tagId}`
              }, _toDisplayString(currentFilter.tagName), 9, _hoisted_8)
            ], 8, _hoisted_3)
          ], 2)
        ]))
      }), 128))
    ])
  ]))
}